import EyebrowLabel from '@/components/SolutionsTemplate/EyebrowLabel';
import FeaturedGrid from "@/components/SolutionsTemplate/FeaturedGrid";
import styles from "@/styles/solutionsTemplate/featuredUseCases.module.scss";

interface Props {
    type: string;
    jsonData: any;
}

export default function FeaturedUseCases({type, jsonData}: Props){

    return(
        <div className = {styles.rootDiv}>
            <EyebrowLabel type = {type} text = {jsonData.eyebrowLabel}/>
            <div className = {styles.titleDiv}>
                {jsonData.title}
            </div>
            <div className = {styles.descriptionDiv}>
                {jsonData.description}
            </div>
            <div style = {{margin: "0 auto", marginTop: "40px", width: "fit-content"}}>
                <FeaturedGrid type = {type} jsonData = {jsonData.gridItems} />
            </div>
            <div style = {{margin: "0 auto", marginTop: "15px", width: "fit-content"}}>
                {jsonData.cta}
            </div>
        </div>
    )
}